import React from 'react';
import { GlassModal, GlassModalHeader, GlassModalBody, GlassModalFooter } from '../../components/GlassModal';
import GlassDataTable from '../../components/GlassDataTable';
import './company-view.css';
import GlassFab from '../../components/glass/GlassFab';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';

class CompanyView extends React.Component {

  state = {
    modal: false,
    newCompany: {}
  }

  handleChange = (value, prop) => {
    var t = this.state.newCompany;
    t[prop] = value;
    this.setState({
      newCompany: t
    });
  }

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newCompany: {},
    });
  }

  edit = (invoice) => {
    this.setState({
      modal: !this.state.modal,
      newCompany: invoice
    });
  }

  componentDidMount() {
    this.props.dispatchGetCompanies();
  }

  createCompany = () => {
    this.props.createCompany(this.state.newCompany);
    this.setState({
      modal: !this.state.modal,
      newCompany: ''
    });
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    var Company = [];
    console.log(this.props);


    if (this.props.companies && this.props.companies.length > 0) {
      Company = this.props.companies.map(p => {
        return {
          name: p.companyName,
          view: <button type="button" onClick={() => this.edit(p)} style={{ background: 'rgba(13,161,178,0.12)', border: '1px solid rgba(13,161,178,0.25)', color: 'var(--primary-dark)', borderRadius: 8, padding: '5px 14px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>Edit</button>,
        }
      });
    }

    const data = {
      columns: [
        {
          label: 'Name',
          field: 'name',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Company
    };

    return (
      <div className="container" style={{ marginTop: 40 }}>
        {this.props.company && <SpinnerView showSpinner={this.props.company.loading} />}

        <GlassDataTable data={data} />

        <GlassFab onClick={this.toggle} />

        <GlassModal isOpen={this.state.modal} toggle={this.toggle}>
          <GlassModalHeader toggle={this.toggle}>{this.state.newCompany._id ? 'Edit Company' : 'New Company'}</GlassModalHeader>
          <GlassModalBody>
            <form>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6 }}>Company Name</label>
              <input type="text" value={this.state.newCompany.name || ''} onChange={(e) => this.handleChange(e.target.value, 'name')} style={{ width: '100%', padding: '11px 14px', border: '1px solid rgba(15,31,46,0.12)', borderRadius: 10, fontSize: 14, outline: 'none', background: 'rgba(255,255,255,0.7)' }} />
            </form>
          </GlassModalBody>
          <GlassModalFooter>
            <button type="button" onClick={this.toggle} style={{ background: 'rgba(15,31,46,0.06)', border: '1px solid rgba(15,31,46,0.10)', color: 'var(--text-secondary)', borderRadius: 10, padding: '9px 16px', fontWeight: 600, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer' }}>Close</button>
            <button type="button" onClick={this.createCompany} style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '9px 18px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer' }}>{this.state.newCompany._id ? 'Save' : 'Create'}</button>
          </GlassModalFooter>
        </GlassModal>
      </div>
    );
  }
}

export default CompanyView;
